module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/address-details/address-details/address-details.component.css
// module id = ./src/app/hrms/serviceregister/address-details/address-details/address-details.component.css
// module chunks = main